import Select, { components, OptionProps, Props, SingleValueProps } from 'react-select';

import InputError from '@/components/common/Messages/InputError';

export type optType = { value: string; label: string | JSX.Element; icon?: JSX.Element };

export type InterfaceSelectedValue = Props<optType, boolean, GroupBase<optType>> & {
  fieldError?: string;
  showFieldError?: boolean;
};

interface GroupBase<Option> {
  readonly options: readonly Option[];
  readonly label?: string;
}

const { Option, SingleValue } = components;

const CustomSingleValue = ({ data, ...innerProps }: SingleValueProps<optType>) => (
  <SingleValue {...innerProps} data={data} className="flex items-center gap-4">
    {data.icon ? data.icon : null}
    <span className="truncate">{data.label}</span>
  </SingleValue>
);

const IconOption = (props: OptionProps<optType>) => (
  <Option {...props}>
    <div className="flex w-full items-center gap-4">
      {props.data.icon ? props.data.icon : null}
      <span className="flex-1 truncate">{props.data.label}</span>
    </div>
  </Option>
);

const ComboBoxWithLogo = ({
  fieldError,
  options,
  components,
  showFieldError = true,
  ...res
}: InterfaceSelectedValue) => {
  // Estilos personalizados para el dropdown
  const customStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      borderWidth: '2px',
      borderColor: state.isFocused ? '#3B82F6' : '#BABABA',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#2563EB',
      },
      minHeight: '40px',
      borderRadius: '0.375rem',
    }),
    menu: (provided: any) => ({
      ...provided,
      borderRadius: '12px', // Más redondo
      overflow: 'hidden',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    }),
    menuList: (provided: any) => ({
      ...provided,
      borderRadius: '12px',
      padding: '4px',
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      minHeight: '32px', // Altura menor de los items
      padding: '6px 12px', // Padding reducido
      borderRadius: '8px',
      margin: '2px 0',
      backgroundColor: state.isSelected
        ? '#3B82F6' // Azul cuando está seleccionado
        : state.isFocused
          ? '#F3F4F6' // Gris cuando tiene hover
          : 'white',
      color: state.isSelected ? 'white' : '#374151',
      '&:hover': {
        backgroundColor: state.isSelected ? '#3B82F6' : '#F3F4F6', // Hover gris
      },
      cursor: 'pointer',
      transition: 'all 0.15s ease-in-out',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      maxWidth: '100%',
    }),
  };

  return (
    <>
      <Select
        options={options}
        components={{ Option: IconOption, SingleValue: CustomSingleValue, ...components }}
        styles={customStyles}
        {...res}
      />

      {showFieldError ? <InputError message={fieldError} /> : null}
    </>
  );
};

export default ComboBoxWithLogo;
